export const getAlternativeYears = alternative => {
  let years = []
  let start = parseInt(alternative.fyStart)
  let numberOfYears = parseInt(alternative.numForecastYears)
  for (let i = 0; i < numberOfYears; i++) {
    years.push(start + i)
  }
  return years
}
